/**
 * mf-jdgm-badge-i18n.js — Medusafilters — v3
 * ---------------------------------------------------------------------------
 * Problem: Judge.me legt das Preview-Badge als vorgerendertes HTML im Metafeld
 * `judgeme.badge` ab, und dieses HTML ist englisch ("872 reviews"). Uebersetzt
 * und sichtbar gemacht wird es erst vom Judge.me-Widget-JS.
 *
 * Dieses Widget-JS laeuft aber nicht ueberall:
 *   - Auf Startseite/Kollektionen wird nur das CSS geladen, nicht das JS
 *     (`window.jdgm.customizeBadges` ist dort undefined).
 *   - Im Quick-Buy-/Cart-Drawer kommt das Badge erst NACH dem Judge.me-Start
 *     ins DOM (Klon aus `#quick-buy-content` der per AJAX geladenen PDP).
 * Ergebnis: englisches "reviews" bzw. Sterne ohne Anzahl.
 *
 * Fix: Badge-Text selbst aus `window.jdgmSettings` + `data-number-of-reviews`
 * bilden — exakt so, wie Judge.me es auch tut, nur ohne Abhaengigkeit vom
 * Widget-JS — und den per CSS versteckten Text danach einblenden
 * (`.jdgm-prev-badge__text{visibility:hidden}` ist Judge.mes Flicker-Schutz).
 * Idempotent: laeuft Judge.me spaeter doch, ist das Ergebnis gleich.
 * Rein additiv, kein Eingriff in Theme- oder App-Code.
 * ---------------------------------------------------------------------------
 */
(function () {
  var BADGE_SELECTOR = '.jdgm-prev-badge';
  var TEXT_SELECTOR = '.jdgm-prev-badge__text';
  var DEBOUNCE_MS = 120;

  var observer = null;
  var timer = null;

  // Judge.me hat fuer den Einzahl-Fall keinen eigenen Text gepflegt, deshalb
  // hier ein deutscher Default statt Judge.mes englischem Fallback.
  function templateFor(count) {
    var s = window.jdgmSettings || {};
    if (count === 0) return s.badge_no_review_text || 'Keine Bewertungen';
    if (count === 1) return s.badge_one_review_text || '1 Bewertung';
    return s.badge_n_reviews_text || '{{ n }} Bewertungen';
  }

  function localize(badge) {
    var textEl = badge.querySelector(TEXT_SELECTOR);
    if (!textEl) return;

    var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
    if (isNaN(count)) return;

    var next = templateFor(count).replace(/\{\{\s*n\s*\}\}/g, count);
    if (textEl.textContent.trim() !== next) {
      textEl.textContent = next;
    }

    // Flicker-Schutz von Judge.me aufheben, nachdem uebersetzt wurde.
    if (textEl.style.visibility !== 'visible') {
      textEl.style.visibility = 'visible';
    }
  }

  function run() {
    timer = null;
    if (!window.jdgmSettings) return;

    // Waehrend des Schreibens nicht selbst beobachten (kein Feedback-Loop).
    if (observer) observer.disconnect();
    try {
      var badges = document.querySelectorAll(BADGE_SELECTOR);
      for (var i = 0; i < badges.length; i++) {
        localize(badges[i]);
      }
    } catch (e) {
      if (window.console && console.warn) {
        console.warn('[mf-jdgm-badge-i18n] failed:', e);
      }
    }
    if (observer) observe();
  }

  function schedule() {
    if (timer) return;
    timer = setTimeout(run, DEBOUNCE_MS);
  }

  function hasBadge(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(BADGE_SELECTOR)) return true;
    return !!(node.querySelector && node.querySelector(BADGE_SELECTOR));
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (hasBadge(added[j])) {
          schedule();
          return;
        }
      }
    }
  }

  function observe() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    if (!document.body) return;
    if (window.MutationObserver) {
      observer = new MutationObserver(onMutations);
      observe();
    }
    // Auch bereits im HTML vorhandene Badges erfassen.
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
